const dummy_t = (translationKey) => translationKey;

export default [
  {
    path: '/knowledge',
    translationKey: dummy_t('menu.knowledge'),
  },
  {
    externalPath: 'https://mamhashi.zendesk.com/hc/pl',
    translationKey: dummy_t('footer.contact'),
  },
];
